function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.386 19.018h-4.239a1.56 1.56 0 01-1.553-1.554v-4.987c0-.844.69-1.553 1.553-1.553.864 0 1.554.69 1.554 1.553v3.472h2.704c.844 0 1.554.69 1.554 1.554 0 .863-.71 1.515-1.573 1.515z",
  fill: "#6E4B22"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.984 12.919C7.52 7.759 12.275 4 17.914 4c6.848 0 12.43 5.582 12.391 12.467 0 6.848-5.581 12.43-12.429 12.43-3.244 0-6.194-1.268-8.41-3.312-.47-.432-.303-1.194.105-1.685.053-.064.105-.131.154-.202l.672-.973c.37-.534 1.154-.553 1.625-.105a8.464 8.464 0 005.854 2.344c4.7 0 8.516-3.817 8.516-8.516 0-4.7-3.817-8.516-8.516-8.516-3.452 0-6.406 2.052-7.749 4.987a8.823 8.823 0 00-.633 2.052H12.314c.25 0 .422.077.518.23.096.154.057.346-.096.576l-4.68 6.732c-.154.23-.326.326-.537.326a.43.43 0 01-.039 0 .606.606 0 01-.091-.006.28.28 0 01-.137-.064.875.875 0 01-.27-.256l-4.834-6.751c-.153-.23-.192-.403-.096-.557.077-.153.269-.23.537-.23h2.973c.077-.69.23-1.38.422-2.052z",
  fill: "#6E4B22"
});

var SvgBtnIcExchangeHistory = function SvgBtnIcExchangeHistory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtnIcExchangeHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btn-ic-exchange-history.efc55e74.svg";
export { ForwardRef as ReactComponent };